import { GridColumnType } from "../../../../data/gridColumnType";


export const AuditlogConfig = {
  columns: [
    {
      name: "Date Time",
      fieldName: "auditDate",
      allowShort: false,
      colType: GridColumnType.DATE,
       colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Description",
      fieldName: "description",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Updated By",
      fieldName: "updatedBy",
      allowShort: false,
      colType: GridColumnType.Text,
    },
  ],
};
